import React, { ReactNode } from 'react';
import { getQueryString, getSortingParams } from '../../../utils/helpers';
import { handleErrorResponse } from '../../../api/network';
import { RouteComponentProps, withRouter } from 'react-router';
import { StyledAntTable } from './Table.style';

enum SortingDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

type Props = RouteComponentProps & {
  columns: any[];
  getData: Function;
  idPropName: string;
  searchPropName?: string;
  searchPropValue?: string;
  bindFetchFn?: Function | null;
  defaultSortingProp?: string;
};

type State = {
  data: any[];
  pagination: {
    current: number;
    pageSize: number;
    total?: number;
    showTotal: (total: number, range: [number, number]) => ReactNode;
  };
  sorting?: {
    direction: SortingDirection;
    property: string;
  };
  loading: boolean;
};

class Table extends React.Component<Props, State> {
  state: State = {
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    },
    sorting: {
      direction: SortingDirection.DESC,
      property: this.props.defaultSortingProp || 'id'
    },
    loading: false
  };

  componentDidMount() {
    this.fetch();
    if (this.props.bindFetchFn) {
      this.props.bindFetchFn(() => this.fetch);
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.searchPropValue !== prevProps.searchPropValue) {
      this.setState(
        {
          pagination: {
            ...this.state.pagination,
            current: 1
          }
        },
        this.fetch
      );
    }
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        pagination,
        sorting: sorter.column
          ? {
              direction: sorter.order === 'ascend' ? SortingDirection.ASC : SortingDirection.DESC,
              property: sorter.field
            }
          : undefined
      },
      () => {
        this.fetch();
      }
    );
  };

  fetch = async () => {
    const {
      pagination: { current, pageSize },
      sorting
    } = this.state;
    const { getData, searchPropName, searchPropValue } = this.props;

    this.setState({ loading: true });

    const response = await getData(
      getQueryString({
        ...(searchPropName ? { [searchPropName]: searchPropValue } : undefined),
        page: current - 1,
        size: pageSize,
        ...(sorting ? { sort: getSortingParams([sorting]) } : undefined)
      })
    );

    if (!response.ok) {
      handleErrorResponse(response, this.props.history);
      this.setState({ loading: false });
      return;
    }

    this.setState({
      loading: false,
      data: response.data.content,
      pagination: {
        ...this.state.pagination,
        total: response.data.totalElements
      }
    });
  };

  render() {
    const { data, pagination, loading } = this.state;
    const { columns, idPropName } = this.props;
    return (
      <StyledAntTable
        columns={columns}
        rowKey={record => record[idPropName]}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={this.handleTableChange}
      />
    );
  }
}

export default withRouter(Table);
